<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <menus></menus>
      </v-col>
      <v-col cols="9">
        <div class="cabinet" style="text-align: center">
          <h1>Кабинет</h1>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Menus from "../views/component/Menus.vue";
export default {
  name: "cabinet",

  components: {
    Menus,
  },
  data() {
    return {};
  },
};
</script>
